export function disabledDates(current: any, end: any) {
  return current && current < end;
}
